import { Pricing } from '@sloyd/ui';
import { Wrapper } from './ContentPricing.style';

export type ContentPricingProps = {
  user: IUser;
  onPlanSelect: (planId: string) => void;
};

export function ContentPricing(props: ContentPricingProps) {
  const { user } = props;

  return (
    <Wrapper className='ContentPricing-wrapper' data-testid='ContentPricing-wrapper'>
      <Pricing user={user} birthday={false} onPlanSelect={props.onPlanSelect} />
    </Wrapper>
  );
}

export default ContentPricing;
